import React from 'react';
import reactStringReplace from 'react-string-replace';
import sortBy from "lodash/sortBy";
import size from "lodash/size";
import moment from "moment";

import {store} from '../main';
import {hardCodeIsLowes} from "../constants/fabricatorHardcode";
import {getParsedJobOrder} from "../components/JobBoard/jobPurchaseOrderPopup/jobOrderFunctions";
import {PARTS} from "../schemas/accessRightsModel";

export function getLeadTypes() {
  return [
    "jobBoard.leadType.Lead",
    "jobBoard.leadType.Quote",
    "jobBoard.leadType.Job",
    "jobBoard.leadType.Change_Order",
    "jobBoard.leadType.Completed",
    "jobBoard.leadType.Dead_Lead"
  ]
}

export function getLeadTypeAsFromBackend(leadType) {
  switch (leadType) {
    case "Change Order":
      return "ChangeOrder"
    case "Dead Lead":
      return "DeadLead"
    case "Completed":
      return "Complete"
    default:
      return leadType
  }
}

export function getStatuses() {
  const {auth, asCustomer} = store.getState();
  const subDomain = asCustomer.data && asCustomer.data.subDomain ? asCustomer.data.subDomain : auth.subDomain;

  if (hardCodeIsLowes(subDomain)) {
    return [
      "jobBoard.jobStatuses.MEASURE_APPT_PENDING",
      "jobBoard.jobStatuses.APPOINTMENT_PENDING",
      "jobBoard.jobStatuses.APPOINTMENT_SET",
      "jobBoard.jobStatuses.APPOINTMENT_RUN",
      "jobBoard.jobStatuses.ORDER_INITIATED",
      "jobBoard.jobStatuses.ITEMS_ORDERED",
      "jobBoard.jobStatuses.PRODUCT_SHIPPED",
      "jobBoard.jobStatuses.PRODUCT_RECEIVED",
      "jobBoard.jobStatuses.PRODUCT_DELIVERED",
      "jobBoard.jobStatuses.INSTALL_PENDING",
      "jobBoard.jobStatuses.COMPLETED",
      "jobBoard.jobStatuses.COMPLETED_PAID",
      "jobBoard.jobStatuses.CANCELLED",
      "jobBoard.jobStatuses.INSTALL_SCHEDULED",
      "jobBoard.jobStatuses.SALE_PENDING",
      "jobBoard.jobStatuses.SALE",
      "jobBoard.jobStatuses.SIT_NO_SALE",
      "jobBoard.jobStatuses.CLOSED",
      "jobBoard.jobStatuses.CLOSED_PENDING",
      "jobBoard.jobStatuses.SIT_NO_SALE_PENDING",
      "jobBoard.jobStatuses.CANCELLED_PENDING",
      "jobBoard.jobStatuses.MEASUREMENT_APPOINTMENT_SET",
      "jobBoard.jobStatuses.MEASUREMENT_APPOINTMENT_RUN",
    ]
  }

  return [
    "jobBoard.jobStatuses.New",
    "jobBoard.jobStatuses.Lead",
    "jobBoard.jobStatuses.Contacted",
    "jobBoard.jobStatuses.Call_Back",
    "jobBoard.jobStatuses.Appointment",
    "jobBoard.jobStatuses.Not_Interested",
    "jobBoard.jobStatuses.Contracted",
    "jobBoard.jobStatuses.Template",
    "jobBoard.jobStatuses.Install",
    "jobBoard.jobStatuses.Complete",
    "jobBoard.jobStatuses.Over_Budget",
    "jobBoard.jobStatuses.Beat_by_Competitor",
    "jobBoard.jobStatuses.No_Answer",
    "jobBoard.jobStatuses.Bad_Contact_info",
    "jobBoard.jobStatuses.Pending_Fabricator_Review",
    "jobBoard.jobStatuses.Pending_Approval",
    "jobBoard.jobStatuses.Installation_Complete",
    "jobBoard.jobStatuses.Cabinets",
    "jobBoard.jobStatuses.Abandoned",
    "jobBoard.jobStatuses.Purchased"
  ];
}

export function getDaysSort() {
  return [
    "jobBoard.daysOpen.Created",
    "jobBoard.daysOpen.Opened",
    "jobBoard.daysOpen.Contacted",
  ];
}

export const getEnglishLeadType = (intlKey) => {
  return intlKey
    ? intlKey
      .replace("jobBoard.leadType.", "")
      .replace("jobBoard.jobStatuses.", "")
      .replace("jobBoard.daysOpen.", "")
      .replace(/_/g," ")
    : intlKey
}

export function getLeadTranslate(job) {
  if (job.isDead) {
    return "jobBoard.leadType.Dead_Lead"
  }
  return "jobBoard.leadType." + job.leadType.replace(/ /g,"_")
}

export function getJobBoardTranslate(status, intlKey = "jobBoard.jobStatuses.") {
  if (!status) {
    return ""
  }
  return (intlKey + status).replace(/ /g,"_")
}

export function getNoteTranslate(noteText, intl) {
  if (!noteText) {
    return null
  }
  const systemNote = "jobBoard.systemNote." + noteText.replace(/ /g,"_");
  if (intl.messages[systemNote]) {
    return intl.formatMessage({id: systemNote})
  }
  let regexr = /\[\s*a.*?href=(?:"|')(.*?)(?:"|').*?](.*?)\[\s*\/a\s*\]/ig;
  let matches = [...noteText.matchAll(regexr)];
  if(matches.length > 0) {
    for(let matchIdx in matches) {
      let match = matches[matchIdx];
      noteText = reactStringReplace(noteText, match[0], () => <a href={match[1]} target='_blank' className='job-board-info__label'>{match[2]}</a>);
    }
  }
  return noteText
}

/**
 * Returns time in format 22D | 3hrs | 2m | 58s
 * @param {object} timePassed // moment js instance
 * @param {object} intl // formatJs(react-intl) instance
 * @returns {string}
 */
export function getJobEntryTime(timePassed, intl) {
  const time = {
    "days": Math.round(timePassed.asDays()),
    "hours": timePassed.get('hours'),
    "minutes": timePassed.get('minutes'),
    "seconds": timePassed.get('seconds'),
  }
  let timeString = "";
  Object.keys(time).forEach(timeKey => {
    const timePart = time[timeKey];
    if (timePart) {
      if (timeString) {
        timeString += " | "
      }
      timeString += timePart + intl.formatMessage({id : "jobBoard.timeShort." + timeKey});
    }
  })
  return timeString
}

/**
 * Toggle Array Value
 * @param {Array} array to toggle
 * @param {object} filterObject
 * @param {boolean} replaceValue
 * @returns {Array}
 */
export const toggleJobBoardFilterSimpleValue = (array, filterObject, replaceValue= false) => {
  let index = array.findIndex(fObject => fObject.name === filterObject.name);
  if (index >= 0) {
    if (replaceValue) {
      array.splice(index, 1, filterObject)
    } else { // removeValue
      array[index].value === filterObject.value ? array.splice(index, 1) : array.splice(index, 1, filterObject)
    }
  } else {
    array.push(filterObject);
  }
  return array;
};

/**
 * Toggle Array Value
 * @param {Array} array to toggle
 * @param {string} filterName
 * @param {string} newValue
 * @returns {Array}
 */
export const toggleJobBoardFilterArrayValue = (array, filterName, newValue = "", selectAll = false) => {
  let index = array.findIndex(fObject => fObject.name === filterName);
  let existingFilter = array.find(fObject => fObject.name === filterName);
  if (existingFilter) {
    if (!Array.isArray(existingFilter.value)) { // just in case
      existingFilter.value = [];
    }
    let index2 = existingFilter.value.findIndex(filterValue => filterValue === newValue); // already selected
    if(selectAll) {
      if(index2 === -1)
        existingFilter.value.push(newValue);
    }else {
      (index2 > -1)
        ? existingFilter.value.splice(index2, 1) // remove selected filter
        : existingFilter.value.push(newValue); // add new one
      if (existingFilter.value.length) {
        array.splice(index, 1, existingFilter);  // update filter
      }
    }
  } else {
    array.push({
      name: filterName,
      value: [newValue]
    });
  }
  return array;
};

/**
 * Toggle Array Value
 * @param {Array} array to toggle
 * @param {object} sortEntityName
 * @returns {Array}
 */
export const toggleJobBoardSortArrayValue = (array, sortEntityName) => {
  let index = array.findIndex(fObject => fObject.name === sortEntityName);
  if (index >= 0) {
    if (array[index].value === "asc") { // second set
      array.splice(index, 1, {name: sortEntityName, value: "desc"})
    } else if (array[index].value === "desc") {
      array.splice(index, 1, {name: sortEntityName, value: "asc"})
      // array.splice(index, 1) // remove
    }
  } else {
    // array.push({name: sortEntityName, value: "asc"}); // first set uncomment if we need several sorting!
    array[0] = {name: sortEntityName, value: "asc"}; // first set
  }
  return array;
};

const roundToSeconds = (momentInstance) => {
  if (momentInstance.millisecond()) {
    const isoString = momentInstance.toISOString(); // "2023-03-09T11:19:01.753Z"
    const splitted = isoString.split(/\./);
    if (splitted.length > 1) {
      const stringAfterDot = splitted[1]; // "753Z"
      if (+(stringAfterDot.replace("Z", "")) > 500) { // we need to round up
        return momentInstance.add(500, 'milliseconds').startOf('second') // "2023-03-09T11:19:02.253Z" // 2023-03-09T11:19:02.000Z
      }
      return momentInstance.startOf('second')
    }
  }
  return momentInstance
}

export const getJobLogEntries = (job, isFullView = false) => {

  const firstEntry = {
    id: 1,
    message: "",
    newStatus: "Started",
    oldStatus: "",
    timestamp: job.created,
    type: "ChangeLeadType",
  };

  if (!Array.isArray(job.logEntries)) {
    return [firstEntry]
  }

  const entries = [...job.logEntries];
  if (!(job.logEntries.length && job.logEntries.some(entry => {
    // added rounding to seconds because job created is 2023-03-09T11:19:02Z and new status is 2023-03-09T11:19:01.753Z
    return roundToSeconds(moment.utc(job.created)).unix() === roundToSeconds(moment.utc(entry.timestamp)).unix()
  }))) {
    entries.push(firstEntry);
  }
  return isFullView ? entries : sortBy(entries, entry => moment.utc(entry.timestamp.split(/\..*$/)[0]).unix())
};

export const getJobMessageHistory = (job, isFullView = false) => {
  return job.messageHistory;
};

export const jobIsFromSalesPerson = (job) => {
  if (job.fromDashboard) {
    return true
  } else if (job.logEntries && job.logEntries.length && job.logEntries.some(entry => {
    return entry.message && entry.message.includes("created by the admin in dashboard");
  })) {
    return true
  }
  return false
}

export const getJobClassName = (job, isClient) => {
  if (job.isDead) {
    return "job-board--Dead"
  }
  if (!isClient) {
    const jobOrder = getParsedJobOrder(job); // jobOrderInterface
    if (jobOrder && jobOrder.invoiceId && !jobOrder.isPaid) {
      return "job-board--Dead"
    } else if (jobOrder && jobOrder.isPaid) {
      return "job-board--Paid"
    }
  }
  return "job-board--" + job.type
}

export const getJobIndicatorTextId = (job, subscriptionType, isClient) => {
  if (isClient) {
    return "jobBoard.moreInformationButton"
  }
  if (subscriptionType === "free") {
    return "jobBoard.buyLeadsButton"
  }
  const jobOrder = getParsedJobOrder(job); // jobOrderInterface
  if (jobOrder && jobOrder.invoiceId && !jobOrder.isPaid) {
    return "jobBoard.paymentRequired"
  } else if (jobOrder && jobOrder.isPaid) {
    return "jobBoard.paid"
  }
  return "jobBoard.moreInformationButton"
}

export const getJobSalesPerson = (job) => {
  if (job.salesPerson == null) {
    if (size(job.quotes)) {
      const q = job.quotes[0];
      if (q.bids.length) {
        job.salesPerson = q.bids[0].quoteSalesPerson;
      }
    }
  }
  return job.salesPerson
}

const hideEditForStatuses = ["Complete", "Completed", "complete", "completed"];

export const editQuoteButtonIsVisible = (job, props) => {
  const {AR, permissions, subscriptionType} = props;
  if (subscriptionType === 'free') {
    return false
  }
  const jobOrder = getParsedJobOrder(job); // jobOrderInterface
  if (jobOrder && jobOrder.orderId) {
    return false
  }
  if (hideEditForStatuses.some(status => job.status === status || job.type === status)) {
    return false
  }
  // old code below
  return (job.jobIdType !== 'Lead' && AR.v(PARTS.SAVE_QUOTE)
      && AR.vJB(PARTS.SAVE_QUOTE, permissions, job.fabricatorId))
    || (job.type === 'Quote' && AR.isClientUser()) && !job.isDead
}
